import React from "react";
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import clsx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";

const useStylesBootstrap = makeStyles(theme => ({
    cellTooltip: {
        padding: '5px 10px',
    },
    nameSection: {
        display: 'flex',
        alignItems: 'center'
    },
    headerContainer: {
        borderBottom: "1px solid #E6EDF5",
        display: "flex",
        flexDirection: "column",
        padding: "5px 10px"
    },
    nameText: {
        display: "inline-block",
        overflow: "hidden"
    },
    nameTextBold: {
        fontSize: "16px",
        display: "inline-block",
        overflow: "hidden",
        fontWeight: "bold"
    },
    genieHeader: {
        fontSize: "12px",
        fontWeight: 700,
        color: '#878787',
        paddingRight: '5px'
    },
    genieData: {
        color: "black",
        fontSize: "12px",
        fontWeight: "bold"
    },
    tooltipBodyContainer: {
        padding: "5px 10px",
    },
}));

export default function EmployeeDataviewTooltip(props) {
    const { ...classes } = useStylesBootstrap();

    let { jsx, listCol, data, employeeName = '' } = props;

    let tooltipEE =
        <React.Fragment>
            <div className={clsx(classes.cellTooltip)}>
                <div className={classes.headerContainer}>
                    <span>{employeeName}</span>
                </div>
                <table className={classes.tooltipBodyContainer}>
                    <tbody>
                        {
                            listCol.map((col, index) => {
                                let field = data.find(d => d.key === col.key)
                                if (field !== undefined) {
                                    return (
                                        <tr key={`employee-dataview-tooltip-row-${index}`}>
                                            <td className={classes.genieHeader}>{col.label}</td>
                                            <td className={classes.genieData}>{field.rawValue}</td>
                                        </tr>
                                    )
                                }
                                return (<></>);
                            })
                        }
                    </tbody>
                </table>
            </div>
        </React.Fragment>

    return (
        <CustomToolTip
            titletext={tooltipEE}
            jsx={jsx}
        />
    );
}